export default function HerQuestions({ session, update, goTo }) {
  // herQuestions is now an array of any length, starting with 1 empty slot.
  const herQuestions =
    session.herQuestions && session.herQuestions.length > 0
      ? session.herQuestions
      : [""];

  const setQ = (i, value) => {
    const next = [...herQuestions];
    next[i] = value;
    update({ herQuestions: next });
  };

  const addQuestion = () => {
    update({ herQuestions: [...herQuestions, ""] });
  };

  const removeQuestion = (i) => {
    if (herQuestions.length <= 1) return;
    const next = herQuestions.filter((_, j) => j !== i);
    update({ herQuestions: next });
  };

  const allFilled = herQuestions.every((q) => q.trim().length > 0);

  return (
    <div className="scene">
      <p
        className="tagline"
        style={{ fontSize: "clamp(1.4rem, 3.5vw, 2rem)", marginBottom: 4 }}
      >
        your turn.
      </p>
      <h2>ask whatever you can think of, and i'll answer.</h2>
      <p
        className="italic"
        style={{ fontSize: "1.05rem", lineHeight: 1.6, marginBottom: 8 }}
      >
        as many as you want. silly, weird, anything. i'll get back to you on all
        of them when we talk next.
      </p>

      {herQuestions.map((q, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            position: "relative",
          }}
        >
          <label
            className="tagline"
            style={{
              fontSize: "0.85rem",
              color: "var(--accent-2)",
              textTransform: "uppercase",
              letterSpacing: "2px",
              fontStyle: "normal",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>question {i + 1}</span>
            {herQuestions.length > 1 && (
              <button
                type="button"
                onClick={() => removeQuestion(i)}
                aria-label="remove"
                style={{
                  background: "transparent",
                  border: "none",
                  color: "var(--muted)",
                  cursor: "pointer",
                  fontSize: "0.85rem",
                  letterSpacing: "1px",
                  fontFamily: "var(--sans)",
                  textTransform: "lowercase",
                  padding: 0,
                }}
              >
                × remove
              </button>
            )}
          </label>
          <textarea
            value={q}
            placeholder="ask away…"
            rows={3}
            onChange={(e) => setQ(i, e.target.value)}
          />
        </div>
      ))}

      <div style={{ marginTop: 4 }}>
        <button
          type="button"
          onClick={addQuestion}
          style={{
            background: "transparent",
            border: "1px dashed var(--line)",
            color: "var(--muted)",
            padding: "10px 16px",
            fontFamily: "var(--sans)",
            fontSize: "0.95rem",
            cursor: "pointer",
            borderRadius: 2,
            width: "100%",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "var(--accent-2)";
            e.currentTarget.style.color = "var(--ink)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "var(--line)";
            e.currentTarget.style.color = "var(--muted)";
          }}
        >
          + add another question
        </button>
      </div>

      <div
        className="row"
        style={{ justifyContent: "space-between", marginTop: 16 }}
      >
        <button className="btn btn-ghost" onClick={() => goTo("questionnaire")}>
          back
        </button>
        <button
          className="btn"
          onClick={() => goTo("miniGame")}
          disabled={!allFilled}
          style={{
            opacity: allFilled ? 1 : 0.4,
            cursor: allFilled ? "pointer" : "not-allowed",
          }}
        >
          next
        </button>
      </div>
    </div>
  );
}
